export default "__VITE_ASSET__wn4gfHRB__"